type ButtonProps = {
  text: string;
  type?: "submit" | "button";
  className?: string;
  handleClick?: () => void;
  children?: React.ReactNode;
  disabled?: boolean;
};

export const Button = ({ text, type, handleClick, className, children, disabled }: ButtonProps) => {
  return (
    <button type={type} onClick={handleClick} className={className} disabled={disabled}>
      {children}
      {text}
    </button>
  );
};
